import React from "react";
import { AHText, Box, useScaleFactor } from "arkh";
import { FormattedMessage } from "react-intl";
import { Logo } from "../../OS/Logo";
import { Image } from "react-native";

export const NoAssignedDashboard = (props: { screenName?: string }) => {
  const sf = useScaleFactor();

  return (
    <Box
      spaceTop="xxlarge"
      style={{
        backgroundColor: "#F4F3F9",
        height: "100%",
        alignItems: "center",
      }}
    >
      <Logo color="surface-cta" width={sf * 110} />
      <AHText
        spaceTop="large"
        style={{
          fontFamily: "poppins-display",
          fontWeight: "800",
        }}
        type="title-big"
      >
        <FormattedMessage
          description="No assigned dashboard title"
          defaultMessage="Which dashboard do you want to go on “{screenName}”?"
          values={{
            screenName: props.screenName,
          }}
        />
      </AHText>
      <AHText
        spaceTop="medium"
        type="list-item-title"
        color="text-secondary"
        style={{
          textAlign: "center",
          width: "50%",
        }}
      >
        <FormattedMessage
          description="No assigned dashboard subtitle"
          defaultMessage="Dashboards can now be connected this this screen!"
        />
      </AHText>
      <Box
        style={{
          flex: 1,
          width: "100%",
          alignItems: "center",
          padding: 80 * sf,
        }}
      >
        <Image
          style={{ maxWidth: "100%", maxHeight: "100%", resizeMode: "contain" }}
          source={require("../../assets/images/dashboard.png")}
        />
      </Box>
    </Box>
  );
};
